// extracted by mini-css-extract-plugin
export default {"container":"OZ1YbeUCiLIAnPJhEHjF","logoContainer":"Lgzmplr6QvLrQlKGClA_","logo":"gI_muFH3NPP58QEzTgR3","text":"oL0sf4MNoD3CkM03zlm_"};